/**
 * profile-edit.js
 */

import React from 'react';
import { useHistory, useRouteMatch } from "react-router-dom";
import { UserContext } from 'contexts/user/user-context';
import MenuDrawer from 'components/menu-drawer';
import BasicDrawerMenu from 'components/menu-drawer/menu/basic-drawer-menu';
import getProfileEditRoutes from './profile-edit-routes';


const ProfileMenu = (props) => {
  const { user } = props;
  const { user: currentUser } = React.useContext(UserContext);
  const profileEditRoutes = getProfileEditRoutes(user, currentUser);
  return (
    <BasicDrawerMenu items={profileEditRoutes} />
  );
}


export default function ProfileEdit(props) {
  const { user } = props;
  const { user: currentUser } = React.useContext(UserContext);
  const history = useHistory();
  const basePath = useRouteMatch();
  const drawerPath = '/edit';
  const drawerBasePath = basePath.url + drawerPath;
  const profileEditRoutes = getProfileEditRoutes(user, currentUser);
  

  const menuRoutes = [{ 
    component: ProfileMenu,
    path: [drawerBasePath]
  }];


  const contentRoutes = profileEditRoutes.map(({ component, path }) => ({
    component,
    path: `${drawerBasePath}${path}`
  }));


  const onCloseDrawer = () => {
    if (props.onClose) {
      props.onClose();
    }
    history.push(basePath.url);
  } 


  return (
    <MenuDrawer
      {...props}
      drawerPath={drawerPath}
      basePath={basePath.url}
      menuRoutes={menuRoutes}
      desktopRoutes={contentRoutes}
      mobileRoutes={contentRoutes} 
      title="EDIT PROFILE"
      onClose={onCloseDrawer}
     />
  )
}